<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <template v-slot:activator="{ on, attrs }">
      <v-btn text color="info" v-bind="attrs" v-on="on">
        View All >
      </v-btn>
    </template>
    <v-card flat>
      <v-card-title>
        Accepted Invitation
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="users"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100]
          }"
        >
          <template v-slot:item.fullName="{ item }">
            <user-chip :user="item"></user-chip>
          </template>
          <template v-slot:item.createdDate="{ item }">
            {{ item.createdDate | normalDate }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DashboardAcceptedInvitationDialog",
  components: {},
  props: { users: { type: Array } },
  data: () => ({
    dialog: false,
    headers: [
      { text: "Name", value: "fullName" },
      { text: "Accepted On", value: "createdDate" }
    ]
  }),
  watch: {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    cancel() {
      this.dialog = false;
    },
    showDialog(type, id) {
      this.dialog = true;
      this.type = type;
      this.id = id ? [id] : [];
      this.changed = true;

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    getInfo() {
      return {
        id: this.id.length > 0 ? this.id[0] : null,
        type: this.type,
        selected: this.selected
      };
    }
  }
};
</script>
